import { render, staticRenderFns } from "./ColorSetting.vue?vue&type=template&id=5d661ee4&scoped=true&"
import script from "./ColorSetting.vue?vue&type=script&lang=js&"
export * from "./ColorSetting.vue?vue&type=script&lang=js&"
import style0 from "./ColorSetting.vue?vue&type=style&index=0&id=5d661ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d661ee4",
  null
  
)

export default component.exports